/**
 * Authorization Roles
 */
export const AuthRoles = {
  superuser: ['superuser'],
  finance: ['superuser', 'finance'],
  admin: ['superuser', 'finance', 'admin'],
  vehicleAdmin: ['superuser', 'admin', 'bb_admin', 'vehicle_admin'],
  bbadmin: ['superuser', 'admin', 'bb_admin'],
  bbreferee: ['bb_referee'],
  bbcoach: ['superuser', 'admin', 'bb_admin', 'bb_coach'],
  bbcoachref: ['superuser', 'admin', 'bb_admin', 'bb_coach', 'bb_referee'],
  bbuser: ['superuser', 'admin', 'bb_admin', 'bb_coach', 'bb_user'],
  //user          : ['superuser','finance','admin','user'],
  onlyGuest: ['guest'],
  onlyLoggedOut: ['loggedOut'],
};
